import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-skull",
  "use": "icon-skull-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-skull\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 0C229.2 0 0 200.6 0 448c0 140.2 73.8 265.2 189 347.4 19.2 13.8 30.4 36.2 27 59.8l-18.8 132.4c-2.8 19.2 12 36.4 31.4 36.4H384v-112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v112h128v-112c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v112h155.4c19.4 0 34.2-17.2 31.4-36.4l-18.8-132.4c-3.4-23.4 7.6-46 27-59.8C950.2 713.2 1024 588.2 1024 448 1024 200.6 794.8 0 512 0z m-192 640c-70.6 0-128-57.4-128-128s57.4-128 128-128 128 57.4 128 128-57.4 128-128 128z m384 0c-70.6 0-128-57.4-128-128s57.4-128 128-128 128 57.4 128 128-57.4 128-128 128z\" p-id=\"3985\">\r\n</path></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/skull.svg
// module id = JBXp
// module chunks = 16